import Axios from '@/assets/js/AxiosPlugin'

// 积分列表
export const exchangeList = params => { return Axios.post('/api/Admin/Points/exchangeList', params) }

// 积分详情
export const exchangeSearch = params => { return Axios.post('/api/Admin/Points/exchangeSearch', params) }

// 积分核销
export const exchangeVerify = params => { return Axios.post('/api/Admin/Points/exchangeVerify', params) }

// 积分备注
export const setExchangeRemark = params => { return Axios.post('/api/Admin/Points/setExchangeRemark', params) }



// WEBPACK FOOTER //
// ./src/views/webpc/CreditMall/ExchangeListApp/apis/index.js